import React from 'react';
import { useParams } from 'react-router-dom';
import useSummaryHandler from './hooks/useSummaryHandler';
import BeforeFinish from './components/BeforeFinish';
import QuestionList from './components/QuestionList';
import Success from './components/Success';
import useJourneyExpiration from '../PatientLandingGeneralComponents/hooks/useJourneyExpiration';

const SurveySummaryPage = () => {
  const { countryCode } = useParams();
  const summaryHandler = useSummaryHandler({ countryCode });
  useJourneyExpiration({ countryCode });

  return (
    summaryHandler.isSummaryStarted ?
      summaryHandler.isFinish ?
        <Success countryCode={countryCode} examName={summaryHandler.examName} hasMoreSurveys={summaryHandler.hasMoreSurveys} />
        :
        <QuestionList summaryHandler={summaryHandler} />
      :
      <BeforeFinish summaryHandler={summaryHandler} />
  );
}

export default SurveySummaryPage;
